/* eslint-disable */
require('./arrow-down-2')
require('./arrow-down')
require('./write-us')
require('./write-input')
require('./arrow-left')
require('./arrow-right-2')
require('./arrow-right')
require('./arrow-right-dark')
require('./arrow-up-2')
require('./arrow-up')
require('./back-icon')
require('./care-green')
require('./care')
require('./close-circle')
require('./close-white')
require('./close')
require('./compass-off')
require('./compass-active')
require('./compass-shape')
require('./compass')
require('./delete')
require('./edit')
require('./eye-cross')
require('./eye')
require('./fail')
require('./finish-red')
require('./finish')
require('./guide-path-red')
require('./guide-path-white')
require('./guide-path')
require('./hamburger')
require('./hand')
require('./handset-green')
require('./handset')
require('./hash')
require('./home')
require('./logo_mobile')
require('./marker')
require('./minus')
require('./mobile_items_care')
require('./mobile_items_services')
require('./path-white')
require('./path')
require('./phone-path')
require('./phone')
require('./plan')
require('./plus_mobile')
require('./plus')
require('./poster-category')
require('./redirect')
require('./scroll-up')
require('./search_mobile')
require('./search-red')
require('./search-without-box')
require('./search')
require('./send')
require('./service-white')
require('./service')
require('./services')
require('./space')
require('./start-step-active-bg')
require('./start-step-bg')
require('./start')
require('./success')
require('./switcher-circle-icon')
require('./warning')
require('./connection')
